import {
    Business,
    Fingerprint,
    Person,
    Close,
    SupervisedUserCircle,
    Lock,
    Check,
    Mail,
} from '@mui/icons-material';
import moment from 'moment';
import unsplash from '../../api/unsplash';
import { useState, useEffect } from 'react';
import PhoneInput from '@quantfive/react-phone-input-2';
import '@quantfive/react-phone-input-2/lib/style.css';
import {
    FormControl,
    Select,
    MenuItem,
    Dialog,
    Button,
    TextField,
} from '@mui/material';
// Costanti per gestione file (definite in fileAutoDelete.ts)
import {
    getTelefonoFromSession,
    getFileAutoDeleteFromSession,
    getIDFromSession,
    getTwoAuthenticateFromSession,
    getPrivacyPolicyFromSession,
    getNotificheAbilitateFromSession,
} from '../../utils/sessionStorageHelpers';
import GlobalSnackbar from '../Snackbar';
import { getTokenFromLocalStorage } from '../../utils/localStorageHelpers';
import { FILE_AUTO_DELETE_VALUES } from '../../constants/fileAutoDelete';

const FieldDisplay = ({ label, value }) => (
    <div className="flex col-span-2 text-lg lg:text-xl lg:col-span-2">
        <div className="mr-2 w-fit sm:w-1/2 lg:w-1/4">{label}:</div> {value}
    </div>
);

const normalizePhone = (number) => {
    const val = (number || '').trim();
    if (val === '' || val === '+' || val === '+39' || val === 'null')
        return null;
    return val;
};

const isValidItalianPhone = (number) => {
    const cleaned = number.replace(/[\s\-()]/g, '');

    return /^\+39[0-9]{8,10}$/.test(cleaned);
};

export const ProfiloLavoratore = () => {
    const ID = getIDFromSession();
    const token = getTokenFromLocalStorage();
    const twoAuthenticate = getTwoAuthenticateFromSession();

    const privacyPolicy = getPrivacyPolicyFromSession();
    const [privacyAccepted, setPrivacyAccepted] = useState(privacyPolicy);
    const [privacyDialog, setPrivacyDialog] = useState(false);

    const initialTelefono = getTelefonoFromSession();
    const [telefono, setTelefono] = useState(initialTelefono);
    const validSessionTelefono = normalizePhone(initialTelefono);

    const initialFileAutoDelete = getFileAutoDeleteFromSession();
    const [fileAutoDelete, setFileAutoDelete] = useState(
        Object.values(FILE_AUTO_DELETE_VALUES).includes(initialFileAutoDelete)
            ? initialFileAutoDelete
            : ''
    );

    const initialNotificheAbilitate = getNotificheAbilitateFromSession();
    const [notificheAbilitate, setNotificheAbilitate] = useState(
        initialNotificheAbilitate
    );

    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [smsSending, setSmsSending] = useState(false);
    const [verifying, setVerifying] = useState(false);
    const [codeValue, setCodeValue] = useState('');
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: '',
        open: false,
    });

    const isTelefonoDirty = telefono !== initialTelefono;
    const isfileAutoDeleteDirty = fileAutoDelete !== initialFileAutoDelete;
    const telefonoNormalized = normalizePhone(telefono);
    const isTelefonoValid =
        telefonoNormalized === null || isValidItalianPhone(telefono);

    useEffect(() => {
        setPrivacyAccepted(privacyPolicy);
    }, [privacyPolicy]);

    useEffect(() => {
        setError(telefonoNormalized !== null && !isValidItalianPhone(telefono));
    }, [telefono, telefonoNormalized]);

    const onHandlePrivacyDialog = async () => {
        if (!token) {
            alert('Token non trovato, effettua il login');
            return false;
        }
        try {
            const res = await unsplash.post(
                'portaleLavoratori/updatePrivacyPolicy',
                { privacy: privacyAccepted },
                {
                    headers: {
                        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
                    },
                }
            );

            if (res.data.success) {
                sessionStorage.setItem(
                    'privacyPolicy',
                    res.data.newPrivacyPolicyValue
                );
                setSnack({
                    severity: 'success',
                    messaggio: res.data.message,
                    open: true,
                });

                setPrivacyDialog(false);
            }
        } catch (e) {
            setSnack({
                severity: 'error',
                messaggio: `Errore durante il salvataggio`,
                open: true,
            });
        }
    };

    const saveUserField = async (field, value) => {
        try {
            setSaving(true);
            await unsplash.put(
                `portaleLavoratori/update${field}`,
                { utente: { ID: ID, [field]: value } },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            sessionStorage.setItem(field, value);
            return true;
        } catch (err) {
            console.error(`Errore durante l’aggiornamento di ${field}:`, err);

            return false;
        } finally {
            setSaving(false);
        }
    };

    const handleStartPhoneVerification = async () => {
        const Telefono = normalizePhone(telefono);
        //se l'utente non vuole inserire un numero o cancellarlo --> viene salvato null e vengono aggiornati TwoAuthenticate e privacyPolicy con value 0 a db
        if (!Telefono) {
            await saveUserField('Telefono', null);
            sessionStorage.setItem('TwoAuthenticate', 0);
            sessionStorage.setItem('privacyPolicy', 0);
            setSnack({
                severity: 'success',
                messaggio: 'Numero rimosso con successo',
                open: true,
            });
            return;
        }
        //se il numero inserito non è valido
        if (!isTelefonoValid) {
            setSnack({
                severity: 'error',
                messaggio: 'Numero non valido',
                open: true,
            });
            return;
        }
        //se il numero è valido, parte il flusso di verifica
        try {
            setSmsSending(true);

            await unsplash.post(
                'portaleLavoratori/startTelefonoVerification',
                { utente: { ID, Telefono } },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setIsDialogOpen(true);

            setSnack({
                severity: 'success',
                messaggio: 'SMS inviato al nuovo numero',
                open: true,
            });
        } catch (err) {
            console.error('Errore invio SMS:', err);

            setSnack({
                severity: 'error',
                messaggio: "Errore durante l'invio SMS",
                open: true,
            });
        } finally {
            setSmsSending(false);
        }
    };

    const handleConfirmPhoneVerification = async () => {
        const Telefono = normalizePhone(telefono);

        if (!codeValue || codeValue.trim().length === 0) {
            setSnack({
                severity: 'error',
                messaggio: 'Inserisci il codice',
                open: true,
            });
            return;
        }

        try {
            setVerifying(true);
            const resp = await unsplash.post(
                'portaleLavoratori/confirmTelefonoVerification',
                { utente: { ID, Telefono, code: codeValue } },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (resp.data && resp.data.success) {
                sessionStorage.setItem('Telefono', Telefono);
                sessionStorage.setItem('TwoAuthenticate', 1);
                if (resp.data.privacyPolicy) {
                    sessionStorage.setItem(
                        'privacyPolicy',
                        resp.data.privacyPolicy
                    );
                }

                setIsDialogOpen(false);
                setCodeValue('');
                setSnack({
                    severity: 'success',
                    messaggio: 'Numero aggiornato con successo',
                    open: true,
                });
            } else {
                setSnack({
                    severity: 'error',
                    messaggio: resp.data?.message ?? 'Codice non valido',
                    open: true,
                });
            }
        } catch (err) {
            console.error('Errore verifica codice:', err);
            setSnack({
                severity: 'error',
                messaggio: 'Errore durante la verifica del codice',
                open: true,
            });
        } finally {
            setVerifying(false);
        }
    };

    const handleSaveFileAutoDelete = async () => {
        const needsConfirmation =
            fileAutoDelete === FILE_AUTO_DELETE_VALUES.DONOTSAVE;

        const confirmed =
            !needsConfirmation ||
            window.confirm(
                'Revocando il permesso elimineremo i file già presenti. Vuoi procedre?'
            );

        if (confirmed) {
            await saveUserField('FileAutoDelete', fileAutoDelete);
        }
    };

    const handleSaveNotificheAbilitate = async () => {
        await saveUserField('NotificheAbilitate', notificheAbilitate);
    };

    return (
        <>
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={snack.open}
                handleCloseSnack={() => setSnack({ ...snack, open: false })}
            />
            <div className="flex w-full ">
                <div className="w-full p-1 text-white rounded-md lg:w-full lg:p-4 bg-azulMiller/70 ">
                    <div className="grid grid-cols-2 my-2 appear-effect">
                        <div className="col-span-2 text-lg lg:text-2xl ">
                            <Fingerprint
                                className="mr-2 text-primary-600"
                                fontSize="large"
                            />
                            Dati Anagrafici
                        </div>
                        <div className="grid grid-cols-2 col-span-2 py-2 pr-2 pl-11 ">
                            <FieldDisplay
                                label="Nome"
                                value={sessionStorage.getItem('Nome')}
                            />
                            <div className="col-span-2 my-1 text-lg border-b-2 lg:text-lg boder-white"></div>

                            <FieldDisplay
                                label="Cognome"
                                value={sessionStorage.getItem('Cognome')}
                            />
                            <div className="col-span-2 my-1 text-lg border-b-2 lg:text-lg boder-white"></div>

                            <FieldDisplay
                                label="CF"
                                value={sessionStorage.getItem('CF')}
                            />
                            <div className="col-span-2 my-1 text-lg border-b-2 lg:text-lg boder-white"></div>
                        </div>

                        <div className="flex items-center col-span-2 mt-4 text-lg lg:text-2xl">
                            <Business
                                className="mr-2 text-primary-600"
                                fontSize="large"
                            />
                            Dati Aziendali
                        </div>
                        <div className="grid grid-cols-2 col-span-2 py-2 pr-2 pl-11">
                            <FieldDisplay
                                label="Mansione"
                                value={sessionStorage.getItem('Mansione')}
                            />
                            <div className="col-span-2 my-1 text-lg border-b-2 lg:text-lg boder-white"></div>

                            <FieldDisplay
                                label="Ragione Sociale"
                                value={sessionStorage.getItem('RagioneSociale')}
                            />
                            <div className="col-span-2 my-1 text-lg border-b-2 lg:text-lg boder-white"></div>
                            <FieldDisplay
                                label="Data Assunzione"
                                value={moment(
                                    sessionStorage.getItem('DataAssunzione')
                                ).format('DD/MM/YYYY')}
                            />
                            <div className="col-span-2 my-1 text-lg border-b-2 lg:text-lg boder-white"></div>
                        </div>

                        <div className="flex items-center col-span-2 mt-4 text-lg lg:text-2xl">
                            <Person
                                className="mr-2 text-primary-600"
                                fontSize="large"
                            />
                            Dati Personali
                        </div>
                        <div className="grid grid-cols-2 col-span-2 py-2 pr-2 pl-11">
                            <div className="flex flex-col col-span-2 text-lg lg:text-xl lg:col-span-2  sm:flex-row">
                                <div className="w-fit w-2/2 sm:w-1/2 lg:w-1/4 ">
                                    Telefono:
                                </div>{' '}
                                <div className="w-fit w-2/2 sm:w-1/2 lg:w-3/4 flex flex-col lg:flex-row gap-2">
                                    {' '}
                                    <div className="max-w-[250.11px] md:max-w-[300px]">
                                        <PhoneInput
                                            country="it"
                                            value={telefono}
                                            onChange={(value) =>
                                                setTelefono(value)
                                            }
                                            inputClass={`text-black max-w-[250.11px] md:max-w-[300px] max-w ${
                                                error
                                                    ? 'border-red-500 border-2'
                                                    : ''
                                            }`}
                                        />
                                        {error && (
                                            <span className="block mt-1 text-sm font-semibold text-red-500">
                                                Inserisci un numero italiano
                                                valido (+39 seguito da 8-10
                                                cifre)
                                            </span>
                                        )}
                                    </div>
                                    <button
                                        onClick={async () => {
                                            await handleStartPhoneVerification();
                                        }}
                                        disabled={
                                            !isTelefonoDirty ||
                                            !isTelefonoValid ||
                                            smsSending
                                        }
                                        className={`max-w-[250.11px] md:max-w-[300px] px-3 py-1  rounded transition-colors duration-200 h-min  ${
                                            !isTelefonoDirty ||
                                            smsSending ||
                                            !isTelefonoValid
                                                ? 'bg-primary-600/50 text-white/50 cursor-not-allowed'
                                                : 'bg-primary-600 text-white hover:bg-primary-700'
                                        }`}
                                    >
                                        {smsSending ? 'Invio...' : 'Salva'}
                                    </button>
                                </div>
                            </div>
                            <div className="col-span-2 mt-2 text-sm text-blue-700 italic font-semibold">
                                Il numero di telefono inserito sarà utilizzato
                                esclusivamente per l'autenticazione a doppio
                                fattore tramite codice OTP inviato via SMS.
                            </div>
                            <div className="col-span-2 my-1 text-lg border-b-2 lg:text-lg boder-white"></div>
                        </div>
                        <div className="grid grid-cols-2 col-span-2 py-2 pr-2 pl-11">
                            <div className="flex flex-col col-span-2 text-lg lg:text-xl lg:col-span-2  sm:flex-row items-center">
                                <div className="w-fit w-2/2 sm:w-1/2 lg:w-1/4">
                                    Gestione documenti sensibili:
                                </div>
                                <div className="w-fit w-2/2 sm:w-1/2 lg:w-3/4 flex flex-col lg:flex-row gap-2">
                                    <FormControl
                                        size="small"
                                        className="w-full max-w-[250.11px] md:max-w-[300px]"
                                    >
                                        <Select
                                            variant="outlined"
                                            value={fileAutoDelete}
                                            onChange={(e) =>
                                                setFileAutoDelete(
                                                    e.target.value
                                                )
                                            }
                                            displayEmpty
                                            className="bg-white rounded h-[35px]"
                                        >
                                            <MenuItem
                                                disabled={twoAuthenticate === "0" ? true : false}
                                                value={
                                                    FILE_AUTO_DELETE_VALUES.NEVER
                                                }
                                            >
                                                Salvataggio permanente
                                            </MenuItem>
                                            <MenuItem
                                                value={
                                                    FILE_AUTO_DELETE_VALUES.AUTO45DAYS
                                                }
                                            >
                                                Cancella dopo 45 giorni
                                            </MenuItem>
                                            <MenuItem
                                                value={
                                                    FILE_AUTO_DELETE_VALUES.DONOTSAVE
                                                }
                                            >
                                                Revoco il permesso
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                    <button
                                        onClick={async () => {
                                            await handleSaveFileAutoDelete();
                                        }}
                                        disabled={
                                            !isfileAutoDeleteDirty || saving
                                        }
                                        className={`max-w-[250.11px] md:max-w-[300px] px-3 py-1 rounded transition-colors duration-200 h-min ${
                                            !isfileAutoDeleteDirty || saving
                                                ? 'bg-primary-600/50 text-white/50 cursor-not-allowed'
                                                : 'bg-primary-600 text-white hover:bg-primary-700'
                                        }`}
                                    >
                                        {saving ? 'Salvataggio...' : 'Salva'}
                                    </button>
                                </div>
                            </div>
                            <div className="col-span-2 my-1 text-lg border-b-2 lg:text-lg boder-white"></div>
                        </div>

                        <div className="flex items-center col-span-2 mt-4 text-lg lg:text-2xl">
                            <Mail
                                className="mr-2 text-primary-600"
                                fontSize="large"
                            />
                            Comunicazioni
                        </div>
                        <div className="grid grid-cols-2 col-span-2 py-2 pr-2 pl-11">
                            <div className="flex flex-col col-span-2 text-lg lg:text-xl lg:col-span-2  sm:flex-row items-center">
                                <div className="w-fit w-2/2 sm:w-1/2 lg:w-1/4">
                                    Ricezione comunicazioni via mail:
                                </div>
                                <div className="w-fit w-2/2 sm:w-1/2 lg:w-3/4 flex flex-col lg:flex-row gap-2">
                                    <FormControl
                                        size="small"
                                        className="w-full max-w-[250.11px] md:max-w-[300px]"
                                    >
                                        <Select
                                            variant="outlined"
                                            value={notificheAbilitate}
                                            displayEmpty
                                            className="bg-white rounded h-[35px]"
                                            onChange={(e) =>
                                                setNotificheAbilitate(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <MenuItem value="1">SI</MenuItem>
                                            <MenuItem value="0">NO</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <button
                                        onClick={async () => {
                                            await handleSaveNotificheAbilitate();
                                        }}
                                        className={`max-w-[250.11px] md:max-w-[300px] px-3 py-1 rounded transition-colors duration-200 h-min ${
                                            saving
                                                ? 'bg-primary-600/50 text-white/50 cursor-not-allowed'
                                                : 'bg-primary-600 text-white hover:bg-primary-700'
                                        }`}
                                    >
                                        {saving ? 'Salvataggio...' : 'Salva'}
                                    </button>
                                </div>
                            </div>
                            <div className="col-span-2 my-1 text-lg border-b-2 lg:text-lg boder-white"></div>
                        </div>

                        <div className="flex items-center col-span-2 mt-4 text-lg lg:text-2xl">
                            <Lock
                                className="mr-2 text-primary-600"
                                fontSize="large"
                            />
                            Dati Sensibili
                        </div>
                        <div className="grid grid-cols-2 col-span-2 py-2 pr-2 pl-11">
                            <div className="flex flex-col col-span-2 text-lg lg:text-xl lg:col-span-2  sm:flex-row">
                                <button
                                    onClick={() => {
                                        setPrivacyDialog(true);
                                    }}
                                    className={`max-w-[250.11px] md:max-w-[300px] px-3 py-1  rounded transition-colors duration-200 h-min  
                                            bg-primary-600 text-white hover:bg-primary-700
                                    `}
                                >
                                    Accetta gestione dati sensibili
                                </button>
                            </div>
                            <div className="col-span-2 my-1 text-lg border-b-2 lg:text-lg boder-white"></div>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                open={privacyDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={'md'}
            >
                <div className="py-6 px-6 lg:px-8">
                    <h3 className="mb-4 text-xl font-medium text-center text-black uppercase">
                        {!twoAuthenticate || !validSessionTelefono
                            ? 'Al momento non è possibile gestire i dati sensibili'
                            : 'Accetta la gestione dei dati sensibili'}
                    </h3>
                    {twoAuthenticate && validSessionTelefono && (
                        <div
                            className="border p-3 rounded mt-4 mb-4"
                            style={{
                                height: '250px',
                                overflowY: 'auto',
                                backgroundColor: '#f9f9f9',
                            }}
                        >
                            <p>
                                Acconsento alla pubblicazione e alla messa a
                                disposizione dei miei referti e documenti
                                sanitari all’interno del portale digitale, in
                                sostituzione della consegna in formato
                                cartaceo. Dichiaro di essere informato che, in
                                mancanza del presente consenso, i referti mi
                                saranno consegnati esclusivamente in formato
                                cartaceo secondo le modalità previste dalla
                                normativa vigente.
                                <br />
                                <br />
                                Selezionando il periodo di conservazione,
                                acconsento alla conservazione dei miei referti e
                                documenti sanitari sul portale digitale del
                                Titolare del trattamento per il periodo da me
                                indicato, anche oltre i 45 giorni previsti dalla
                                normativa standard in materia di consegna dei
                                referti (Gazzetta Ufficiale n. 288 dell’11
                                dicembre 2009), al solo fine di consentirne la
                                consultazione e il download da parte mia. Sono
                                informato che la scelta è facoltativa e che, in
                                assenza di consenso alla conservazione oltre i
                                45 giorni, i referti saranno resi disponibili
                                esclusivamente per il periodo minimo previsto
                                dalla normativa vigente.
                                <br />
                                <br />
                                Seleziona il periodo di conservazione dei
                                referti sul portale: 45 giorni (periodo minimo
                                previsto) / Oltre 45 giorni fino a revoca del
                                consenso.
                                <br />
                                <br />I consensi sopra espressi possono essere
                                revocati in qualsiasi momento, senza formalità,
                                tramite il portale o contattando il Titolare del
                                trattamento, ferma restando la liceità del
                                trattamento effettuato prima della revoca.
                            </p>
                        </div>
                    )}

                    {(!twoAuthenticate || !validSessionTelefono) && (
                        <p className="text-red-500 bold font-semibold">
                            Per abilitare la gestione dei dati sensibili,
                            inserisci un numero di telefono valido all'interno
                            della sezione
                            <em>Dati Personali</em>.
                        </p>
                    )}

                    <div className="my-4 flex items-center gap-2">
                        <input
                            type="checkbox"
                            id="accettaPrivacy"
                            checked={privacyAccepted}
                            onChange={(e) =>
                                setPrivacyAccepted(e.target.checked)
                            }
                            disabled={!twoAuthenticate || !validSessionTelefono}
                            className={`w-5 h-5  ${!twoAuthenticate || !validSessionTelefono ? 'cursor-text' : 'cursor-pointer'}`}
                        />
                        <label
                            htmlFor="accettaPrivacy"
                            className={`cursor-pointer ${!twoAuthenticate || !validSessionTelefono ? 'text-black/50 cursor-text' : ''}`}
                        >
                            Accetto la gestione dei dati sensibili
                        </label>
                    </div>

                    <div className="w-full">
                        <div className="flex justify-between mt-4 ">
                            <Button
                                className="ButtonMiller"
                                variant="contained"
                                startIcon={<Close />}
                                onClick={() => {
                                    setPrivacyDialog(false);
                                    setPrivacyAccepted(privacyPolicy);
                                }}
                            >
                                Annulla
                            </Button>
                            {twoAuthenticate && validSessionTelefono && (
                                <Button
                                    className={`ButtonMiller`}
                                    variant="contained"
                                    startIcon={<Check />}
                                    disabled={
                                        !twoAuthenticate ||
                                        !validSessionTelefono
                                    }
                                    onClick={() =>
                                        onHandlePrivacyDialog(
                                            privacyAccepted ? 1 : 0
                                        )
                                    }
                                >
                                    Salva
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </Dialog>
            <Dialog
                open={isDialogOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="md"
            >
                <div className="py-6 px-6 lg:px-8">
                    <h3 className="mb-4 text-xl font-medium text-center text-black">
                        Inserire il codice inviato via sms al numero inserito
                    </h3>

                    <div className="w-full">
                        <TextField
                            label="Codice"
                            variant="outlined"
                            fullWidth
                            value={codeValue}
                            onChange={(e) => setCodeValue(e.target.value)}
                            disabled={verifying}
                        />
                        <div className="flex justify-between mt-4 ">
                            <Button
                                className="ButtonMiller"
                                variant="contained"
                                startIcon={<Close />}
                                onClick={() => {
                                    setIsDialogOpen(false);
                                    setCodeValue('');
                                }}
                            >
                                Annulla
                            </Button>
                            <Button
                                className="ButtonMiller"
                                variant="contained"
                                startIcon={<SupervisedUserCircle />}
                                onClick={() => {
                                    handleConfirmPhoneVerification();
                                }}
                                disabled={verifying}
                            >
                                {verifying
                                    ? 'Verifico...'
                                    : 'Salva nuovo numero'}
                            </Button>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
};
